module.exports = __webpack_public_path__ + "static/media/24-7.a2adff62.svg";